// extracted by mini-css-extract-plugin
export default {"shipping":"shipping_shipping__jz6ZJ"};